import NProgress from 'nprogress'; // progress bar
import Vue from 'vue';
import router from '@/router/router';
import baseRouterMap from '@/router/baseRouterList';
import 'nprogress/nprogress.css'; // progress bar style
import { getStorage } from '@/utils/storage';
import { hasState, clearState } from '@/utils/loginStatePersist.js';

// NProgress 配置
NProgress.configure({ showSpinner: true });

// 判断是否有token
const checkToken = () => {
  return hasState();
};


const checkIsPermission = (permission) => {
  const { user = {} } = getStorage('vuex') || {};
  const { menuList } = user;
  return menuList.includes(permission);
};

// 切换路由时清空上个路由未完成的所有请求
const cancelRequest = () => {
  Vue.prototype.cancelList.forEach((cancel) => {
    cancel();
  });
  Vue.prototype.cancelList = [];
};

// router进入前的判断
router.beforeEach((to, from, next) => {
  if (!checkToken()) {
    clearState();
  }

  if (to.fullPath === from.fullPath) {
    return false;
  }
  if (!to.name) {
    next({ name: 'exception404', replace: true });
  }

  // 使用nprogress进度条
  NProgress.start();
  cancelRequest();

  if (!to.meta.loginRequired) {
    // 如果有token并且进入登录页面，直接跳转到首页
    if (to.name === 'login' && checkToken()) {
      next({ name: 'dashboard', replace: true });
      NProgress.done();
      return false;
    }
    next();
    NProgress.done();
    return false;
  }


  if (checkToken()) {
    const { meta } = to;
    const { permission } = meta;
    if (permission && !checkIsPermission(permission)) {
      next({ path: '/404', replace: true });
    }
    next();
    NProgress.done();
    return false;
  }


  next({ name: 'login', replace: true });
  NProgress.done();
  return false;
});
